import {
  GET_AUDITTRAIL_META,
  GET_AUDITTRAIL_LIST,
  GET_AUDITTRAIL_DETAILS,
} from "resources/actionTypes";

const initialAuditTrailMetaState = {
  loading: false,
  error: null,
  auditTrailMeta: null,
};

const initialAuditTrailListState = {
  loading: false,
  error: null,
  auditTrailList: null,
};

const initialAuditTrailDetailsState = {
  loading: false,
  error: null,
  auditTrailDetails: null,
};

// Audit Trail Meta Reducer
export const auditTrailMetaReducer = (
  state = initialAuditTrailMetaState,
  action,
) => {
  switch (action.type) {
    case GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_SUCCESS:
      return {
        ...state,
        loading: false,
        auditTrailMeta: action.auditTrailMeta,
      };

    case GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    case GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_RESET:
      return {
        ...initialAuditTrailMetaState,
      };

    default:
      return state;
  }
};

// Audit Trail List Reducer
export const auditTrailListReducer = (
  state = initialAuditTrailListState,
  action,
) => {
  switch (action.type) {
    case GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        auditTrailList: action.auditTrailList,
      };

    case GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    case GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_RESET:
      return {
        ...initialAuditTrailListState,
      };

    default:
      return state;
  }
};

// Audit Trail Details Reducer
export const auditTrailDetailsReducer = (
  state = initialAuditTrailDetailsState,
  action,
) => {
  switch (action.type) {
    case GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        auditTrailDetails: action.auditTrailDetails,
      };

    case GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    case GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_RESET:
      return {
        ...initialAuditTrailDetailsState,
      };

    default:
      return state;
  }
};
